module.exports = __webpack_public_path__ + "static/desktop-banner-homepage-new-24Nov-067187fe722d796979ded5b5f9a3c3b4.jpg";